<div class="flex flex-col items-center gap-4">
  <h3 class="font-semibold text-center w-full px-2 mb-0">
    {{ 'integrationConfig.title' | transloco }}
  </h3>

  <div class="flex gap-1">
    <p-button
      [disabled]="isReadOnly()"
      [label]="'common.yes' | transloco"
      [outlined]="yesNoSelection() !== true"
      [severity]="yesNoSelection() === true ? 'primary' : 'secondary'"
      (onClick)="onYesNoToggle(true)"
      size="small"
    />
    <p-button
      [disabled]="isReadOnly()"
      [label]="'common.no' | transloco"
      [outlined]="yesNoSelection() !== false"
      [severity]="yesNoSelection() === false ? 'primary' : 'secondary'"
      (onClick)="onYesNoToggle(false)"
      size="small"
    />
  </div>

  @if (yesNoSelection() === true) {
    <div class="flex flex-col items-stretch gap-2 w-full px-2">
      @if (selectedDataDomains().length > 0) {
        <div class="flex flex-col gap-2 mb-2 w-full">
          @for (domainId of selectedDataDomains(); track domainId) {
            <p-chip
              [removable]="!isReadOnly()"
              [label]="getDataDomainLabel(domainId) | translateDirectus"
              (onRemove)="removeDataDomain(domainId)"
              class="chip-truncate justify-between"
            />
          }
        </div>
      }

      <app-model-field-multiselect
        [id]="'data-domain-multiselect-' + temporaryIdentifier()"
        [isReadOnly]="isReadOnly()"
        label="integrationConfig.selectDataDomains"
        [showSelectionLabel]="false"
        [selectTranslatedOptions]="dataDomainOptions()"
        [(value)]="selectedDataDomains"
        (valueChange)="emitChange()"
        [isRequired]="true"
        [invalid]="areDataDomainsMissing()"
        class="w-full"
      />

      <app-model-field-select
        [id]="'integration-type-select-' + temporaryIdentifier()"
        [isReadOnly]="isReadOnly()"
        label="integrationConfig.selectIntegrationType"
        [options]="integrationTypeOptions()"
        optionValue="id"
        [(value)]="selectedIntegrationType"
        (valueChange)="emitChange()"
        [showClear]="false"
        [isRequired]="true"
        [invalid]="isIntegrationTypeMissing()"
        class="w-full"
      />
    </div>
  }
</div>
